import React from 'react'
import { useHistory } from "react-router-dom";
import {
  DoorDetail,
  User
} from 'apis/response_types'
import Dialog from '@material-ui/core/Dialog'
import CancelIcon from '@material-ui/icons/Close'
import CardActionArea from '@material-ui/core/CardActionArea'
import DefaultUserIcon from '../../images/default_user_icon.jpg'

export default function DoorLoginModal(props: {
  door: DoorDetail
  owner: User
  isOpen: boolean
  setIsOpen: Function
  callbackPath: string
}) {
  const { door, owner, isOpen, setIsOpen, callbackPath } = props
  const history = useHistory()

  const handleClickLink = (to: string) => {
    return () => {
      window.gtag('event', 'click', {
        event_category: 'NM Subscribe Door Button With TW'
      })
      history.push(to, {
        redirect: callbackPath
      })
    }
  }

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={() => {
          setIsOpen(false)
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <section className="modal" id="modal-door">
          <div className="modal-header">
            <div id="alert-dialog-title" className="title">
              このサロンに入りますか？
            </div>
            <div className="close modal-close">
              <CancelIcon
                onClick={() => {
                  setIsOpen(false)
                }}
                color="disabled"
              />
            </div>
          </div>
          <div className="modal-contents">
            <div className="modal-user">
              <div
                className="icon"
                style={{
                  backgroundImage: `url(${
                    owner.icon ? owner.icon : DefaultUserIcon
                  })`,
                  backgroundSize: 'cover',
                  backgroundPosition: '50% 50%'
                }}
              ></div>
              <div className="title">{door != null ? door.title : ''}</div>
              <div className="username">{owner.name}</div>
            </div>
            <CardActionArea>
              <a
                className="btn btn-twitter btn-block"
                onClick={handleClickLink('/signup')}
              >
                新規登録して参加する
              </a>
            </CardActionArea>
            <CardActionArea>
              <a
                onClick={handleClickLink('/signin')}
              >
                <div
                  style={{ textDecoration: 'underline', cursor: 'pointer' }}
                  className="text-center mt1"
                >
                  ログインして参加する
                </div>
              </a>
            </CardActionArea>
          </div>
        </section>
      </Dialog>
    </div>
  )
}
